import React from 'react';
import Alert from 'react-bootstrap/Alert';
import { useAppDispatch } from '@store/hooks';
import { closeBanner } from '@store/reducers/bannerSlice';

import './banner.scss';
import { IconWarningAlt, InlineNotification } from '@veneer/core';

const Banner: React.FC = () => {
    const dispatch = useAppDispatch();
    return (
        <div className="banner-container">
            <InlineNotification
            actionPlacement="top"
            closeButton={true}
            customStyle={{ width: '100%',  }}
            description= {<p dangerouslySetInnerHTML={{__html: (window as any).bannerMessage}}></p>}
            type="warning"
            onClose={() => dispatch(closeBanner())}
            />
           
        </div>
    );
};

export default Banner;